import { STUDENT_DETAIL_ROUTES } from "../../modules/constants";
import GradeLevels from "./components";

export default () => ({
  path: STUDENT_DETAIL_ROUTES.CONFIGURE_GRADE_LEVELS,
  component: GradeLevels,
});
